<template>
  <div
    id="app-container"
    :class="menuType">
    <crm-toolbar class="flex-no-grow" />
    <crm-sidebar />
    <main>
      <div class="container-fluid">
        <router-view :key="$route.path" />
      </div>
    </main>
  </div>
</template>

<script>
import CrmToolbar from 'components/CapTool/NavigationToolbar/TopNav'
import CrmSidebar from 'components/CapTool/Sidebar/Sidebar'
import { mapGetters } from 'vuex'

export default {
  name: 'CapToolMainPage',

  components: {
    CrmToolbar,
    CrmSidebar
  },

  computed: {
    ...mapGetters({
      menuType: 'menu/getMenuType'
    })
  }
}
</script>

<style>
@media (min-width: config('screens.xl')) {
  .router-view-container {
    max-width: config('screens.xl');
  }
}

@media (min-width: config('screens.lg')) and (max-width: config('screens.xl')) {
  .router-view-container {
    max-width: config('screens.lg');
  }
}
</style>
